import styled from 'styled-components';

export default styled.div`
    display: flex;
    flex-direction: column;
    max-width: 800px;
    margin: 0 auto;
    border-left: 1px solid #efefef;
    border-right: 1px solid #efefef;
    padding: 4rem;
    background-color: #fff;
    margin-top: 0.25rem;

    @media(max-width: 768px) {
        padding: 1rem;
        margin-top: 0;
    }
`